module.exports = __webpack_public_path__ + "../resources/images/numbering-bce46fa5f2be658a6e4f36b0f4475e36.svg";